import React from 'react'
import { Container } from 'react-bootstrap'
import useFetch from '../../../Hooks/useFetch'

import './text-header.scss'

export default function TextHeader({ projectNumber }) {
  const { data } = useFetch()

  // console.log(projectNumber)
  // console.log(data?.items[projectNumber])
  return (
    <div id='text-header'>
      <h2>{projectNumber?.fields.tTitle}</h2>
      <ul>
        <li>Project Name: {projectNumber?.fields.tUi.Project_Name}</li>
        <li>Location: {projectNumber?.fields.tUi.Location}</li>
        <li>Area From: {projectNumber?.fields.tUi.Area_From}</li>
      </ul>
      {/* <p>
        Effortless luxury featuring elegant 1, 2, 3 and 4-bedroom apartments,
        exquisite townhouses and lush penthouses.
      </p> */}
    </div>
  )
}
